import { Colors } from "../../../consts/Colors";

export default class Dot extends Phaser.GameObjects.Container {
    constructor(scene, ordi, x, y, id) {
        super(scene, x, y, []);

        this.scene = scene;
        this.ordi = ordi;
        this.isConnected = false
        this.id = id
        scene.add.existing(this);

        this.background = this.scene.add.circle(0, 0, 35, Colors.Elmt.Red, 0).setOrigin(0.5);
        this.add(this.background);

        this.setSize(this.background.width, this.background.height);
        this.setInteractive({useHandCursor: true, dropZone: true});

        this.on('pointerdown', this.onPointerDown, this);
        this.on('pointerover', this.onPointerEnter, this);
    }

    onPointerDown(pointer){
        this.ordi.createLine(this, this.x, this.y);
    }

    onPointerEnter(pointer, gameObject){
        if(this.isConnected) return
        console.log("enter")
        this.ordi.addLinePoint(this, this.x, this.y);
    }

    setConnected(isConnected){
        this.isConnected = isConnected
    }

    reset(){
        this.isConnected = false
    }
}